import { Link } from 'react-router-dom';

export interface BlogPost {
  slug: string;
  title: string;
  excerpt: string;
  imageUrl: string;
  category: string;
  publishedAt: string;
  author: string;
  readingTime?: string;
}

interface BlogCardProps {
  post: BlogPost;
}

export function BlogCard({ post }: BlogCardProps) {
  const formattedDate = new Date(post.publishedAt).toLocaleDateString('es-PE', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  return (
    <article className="bg-white rounded-xl shadow-sm border overflow-hidden hover:shadow-md transition-shadow">
      <Link to={`/blog/${post.slug}`} className="block">
        <div className="aspect-video relative overflow-hidden bg-gray-100">
          {post.imageUrl ? (
            <img
              src={post.imageUrl}
              alt={post.title}
              className="w-full h-full object-cover transition-transform hover:scale-105"
              loading="lazy"
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center text-gray-400">
              <ImagePlaceholder className="w-12 h-12" />
            </div>
          )}
          <span className="absolute top-3 left-3 px-3 py-1 text-xs font-medium bg-orange-500 text-white rounded-full">
            {post.category}
          </span>
        </div>
      </Link>

      <div className="p-5">
        <div className="flex items-center gap-2 text-sm text-gray-500 mb-2">
          <time dateTime={post.publishedAt}>{formattedDate}</time>
          {post.readingTime && (
            <>
              <span>·</span>
              <span>{post.readingTime}</span>
            </>
          )}
        </div>

        <Link to={`/blog/${post.slug}`}>
          <h3 className="text-lg font-semibold text-gray-900 hover:text-orange-500 transition-colors line-clamp-2">
            {post.title}
          </h3>
        </Link>

        <p className="mt-2 text-gray-600 text-sm line-clamp-3">
          {post.excerpt}
        </p>

        <div className="mt-4 flex items-center justify-between">
          <span className="text-sm text-gray-500">Por {post.author}</span>
          <Link
            to={`/blog/${post.slug}`}
            className="text-sm font-medium text-orange-500 hover:text-orange-600"
          >
            Leer mas →
          </Link>
        </div>
      </div>
    </article>
  );
}

function ImagePlaceholder({ className }: { className?: string }) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
      />
    </svg>
  );
}
